define('display/svgIcon',['leaflet'], function (L) {
    'use strict';

    var stylesCache = {};

    function setNodeIconAnchorStyle(options, node) {
        if (options.iconAnchor) {
            var anchor = L.point(options.iconAnchor);
            node.style.marginLeft = (-anchor.x) + 'px';
            node.style.marginTop = (-anchor.y) + 'px';
        }
    }

    function setNodeStyleFromStyleOption(options, node) {
        var css;
        for (css in options.style) {
            if (options.style.hasOwnProperty(css)) {
                node.style[css] = options.style[css];
            }
        }
    }

    function setNodeStyle(node, options) {
        node.style.width = options.iconSize[0] + 'px';
        node.style.height = options.iconSize[1] + 'px';
        node.style.backgroundSize = options.iconSize[0] + 'px ' + options.iconSize[1] + 'px';
        setNodeIconAnchorStyle(options, node);
        node.style.position = 'absolute';
        node.style.textAlign = 'center';
        node.style.verticalAlign = 'middle';
        node.style.lineHeight = options.iconSize[1] + 'px';
        if (options.style) {
            setNodeStyleFromStyleOption(options, node);
        }
    }

    function getStyleByClassName(className) {
        var styleSheets = document.styleSheets,
            classes,
            i, j;
        for (i = 0; i < styleSheets.length; i += 1) {
            classes = styleSheets[i].rules || styleSheets[i].cssRules || [];
            for (j = 0; j < classes.length; j += 1) {
                if (classes[j].selectorText && classes[j].selectorText.indexOf('.' + className) > -1 && classes[j].style['background-image']) {
                    return classes[j].style['background-image'];
                }
            }
        }
    }

    function getCachedStyleByClassName(className) {
        if (!stylesCache[className]) {
            stylesCache[className] = getStyleByClassName(className);
        }
        return stylesCache[className];
    }

    function extractBackgroundToPlainSVG(node, options, className) {
        var svg = window.getComputedStyle(node).getPropertyValue('background-image') || getCachedStyleByClassName(className),
            match;
        if (!svg) {
            return;
        }
        match = svg.match(/(%3Csvg[^"']+%3C%2Fsvg%3E)/i);
        if (!match) {
            return;
        }
        svg = decodeURIComponent(match[1]);
        node.innerHTML = svg;
        node.firstChild.setAttribute('width', options.iconSize[0] + 'px');
        node.firstChild.setAttribute('height', options.iconSize[1] + 'px');
        node.firstChild.setAttribute('style', 'display: block; position: absolute;');
        node.style.backgroundImage = 'none';
    }

    function createDiv(options, parent) {
        var node = L.DomUtil.create('div', 'icon ' + (options.icon || 'content'), parent);
        setNodeStyle(node, options);
        if (options.icon && !options.noPlainSVG) {
            extractBackgroundToPlainSVG(node, options, options.icon);
        }
        if (options.content) {
            node.innerHTML = options.content;
        }
        return node;
    }

    function createImg(options, parent) {
        var node = L.DomUtil.create('div', 'icon-image', parent),
        img = L.DomUtil.create('img', 'icon-image-img', node);
        img.style.width = options.iconSize[0] + 'px';
        img.style.height = options.iconSize[1] + 'px';
        if (/^http/i.test(options.icon)) {
            img.src = options.icon;
        } else {
            img.src = L.Icon.Default.imagePath + '/' + options.icon;
        }
        setNodeStyle(node, options);
        return node;
    }

    function isFile(name) {
        return (/\.(gif|jpg|jpeg|tiff|png|svg)$/i).test(name);
    }

    function createNode(options, parent) {
        if (L.Browser.svg && !isFile(options.icon)) {
            return createDiv(options, parent);
        }
        return createImg(options, parent);
    }

    var defaultOptions = {
        background: {
            iconSize: L.Browser.retina ? [50, 60] : [30, 36],
            iconAnchor: L.Browser.retina ? [25, 60] : [15, 36],
            icon: 'icon-marker',
            noPlainSVG: false
        },
        icon: {
            iconSize: L.Browser.retina ? [50, 50] : [30, 30],
            iconAnchor: [0, 0],
            icon: 'icon-flag-white',
            noPlainSVG: false
        },
        popupAnchor: L.Browser.retina ? [0, -50] : [0, -30],
        opacity: 0.8
    };

    function mergeOptions(result, source, option) {
        if (source.hasOwnProperty(option)) {
            result[option] = source[option] ? L.extend({}, defaultOptions[option], source[option]) : null;
        }
    }

    /**
     *   options: {
     *       background: {
     *           iconSize: L.Browser.retina ? [50, 60] : [30, 36],
     *           iconAnchor: L.Browser.retina ? [25, 60] : [15, 36],
     *           icon: 'marker',
     *           noPlainSVG: false
     *       },
     *       icon: {
     *           iconSize: L.Browser.retina ? [50, 50] : [30, 30],
     *           iconAnchor: [0, 0],
     *           icon: 'flag-white',
     *           noPlainSVG: false
     *       },
     *       content: {
     *           iconSize: [30, 30],
     *           iconAnchor: [0, 0],
     *           content: '',
     *           noPlainSVG: true,
     *           style: {
     *               'color': '#fff',
     *               'font-weight': 'bold',
     *               'font-size': '20px'
     *           }
     *       }
     *       popupAnchor: L.Browser.retina ? [0, -50] : [0, -30],
     *       opacity: 0.8
     */

    L.SVGIcon = L.Icon.extend({
        initialize: function (options) {
            this.options = L.Util.extend({}, defaultOptions, options);
            if (!options) {
                return;
            }
            mergeOptions(this.options, options, 'background');
            mergeOptions(this.options, options, 'icon');
        },

        createIcon: function () {
            var options = this.options;
            this.container = createNode(options.background || options.icon);
            if (options.background && options.icon && options.icon.icon) {
                createNode(options.icon, this.container);
            }
            if (options.content) {
                this.contentContainer = createDiv(options.content, this.container);
            }
            L.DomUtil.setOpacity(this.container, options.opacity);
            return this.container;
        },

        setContent: function (content) {
            if (this.contentContainer) {
                this.contentContainer.innerHTML = content;
            }
        },

        setOpacity: function (opacity) {
            this.options.opacity = opacity;
            L.DomUtil.setOpacity(this.container, opacity);
        }
    });

    L.svgIcon = function (options) {
        return new L.SVGIcon(options);
    };

    return L.SVGIcon;
});
